module.exports = __webpack_public_path__ + "img/pngegg-768x480.fb751099.png";